import { render, staticRenderFns } from "./AbnormalMaterial.vue?vue&type=template&id=5c135bc7"
import script from "./AbnormalMaterial.vue?vue&type=script&lang=js"
export * from "./AbnormalMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports